import Carousel from 'react-bootstrap/Carousel';

function TH() {
  return (
    <Carousel  indicators={false} className="goals-carousel concrete-carousel" >
      
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="./images/39.jpeg"
          alt="Third slide"
        />
        
      </Carousel.Item>

       

    </Carousel>
  );
}

export default TH;